import {
	Box,
	CircularProgress,
	FormControl,
	FormLabel,
	Grid,
	MenuItem,
	Theme,
	Typography,
	makeStyles,
} from '@material-ui/core';
import { Button } from 'src/components/Button';
import { type ChangeEvent, Fragment, useEffect, useState } from 'react';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Dialog } from 'src/components/Dialog';
import { type ICourse, type IInstitution } from 'src/models';
import { TextField } from 'src/components/TextField';
import { getTime, timeString, useIsMobile } from 'src/helpers';
import CalendarIcon from '@material-ui/icons/Event';
import MomentUtils from '@date-io/moment';
import moment from 'moment';

import { useDispatch, useSelector } from 'react-redux';
import courseActions from 'src/store/Courses/actions';
import institutionActions from 'src/store/Institutions/actions';
import userActions from 'src/store/Users/actions';
import { Autocomplete } from 'src/components';

interface AdvancesDialogProps {
	open: boolean;
	handleOpen: () => void;
	type: 'advances' | 'qualifications';
}

export function AdvancesDialog({
	handleOpen,
	open,
	type,
}: AdvancesDialogProps) {
	// NOTE: Ver todas las notas de ./src/modules/private/Admin.tsx
	const dispatch = useDispatch();
	const isMobile = useIsMobile();

	const user = useSelector((state) => state.auth.data);
	const courses = useSelector((state) => state.courses.courses);
	const institutions = useSelector(
		(state) => state.institutions.institutions,
	);
	const isDownloading = useSelector(
		(state) => state.courses.isDownloadingReport,
	);

	const [institutionId, setInstitutionId] = useState(user.institutionId || 0);
	const [date, setDate] = useState<Date>(new Date());
	const [courseId, setCourseId] = useState(0);

	// NOTE:
	// Las funciones deberían de declararse hasta al final del componente, antes del render.
	// Recomendación: Las funciones que se usen únicamente dentro del hook useEffect se deben
	// de declarar dentro del mismo.

	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[77:8]
	function handleInstitutionChange(event: ChangeEvent<HTMLInputElement>) {
		setInstitutionId(parseInt(event.target.value));
		dispatch(courseActions.getByInstitution(parseInt(event.target.value)));
	}

	// NOTE:
	// ./src/modules/Private/Courses/Course.tsx[77:8]
	function handleDowload() {
		dispatch(
			courseActions.downloadReport(
				type,
				institutionId,
				courseId,
				moment(date).year(),
			),
		);

		if (type === 'qualifications') {
			handleOpen();
		}
	}

	useEffect(() => {
		setInstitutionId(user?.institutionId || 0);
	}, [user?.institutionId]);

	useEffect(() => {
		if (open) {
			if (user.type === 'Admin') dispatch(institutionActions.getAll());
			else dispatch(courseActions.getByInstitution(user.institutionId));
		} else {
			setInstitutionId(0);
			setCourseId(0);
			dispatch(
				userActions.setCertificates([], {
					totalPages: 0,
					totalResults: 0,
				}),
			);
		}
	}, [open]);

	return (
		<Dialog
			actions={
				<Button
					actionType={'save'}
					disabled={
						institutionId === 0 || courseId === 0 || isDownloading
					}
					onClick={handleDowload}
					style={{ minWidth: 140 }}
				>
					{isDownloading ? (
						<CircularProgress size={26} />
					) : (
						'Descargar'
					)}
				</Button>
			}
			content={
				<Grid container>
					{user.type === 'Admin' && (
						<Grid item xs={12} style={{ marginBottom: 16 }}>
							<Autocomplete
								getOptionLabel={(option: any) => option.name}
								label={'Institución'}
								onChange={(e: ChangeEvent<any>, values: any) => {
									console.log("value", values, values?.id);
									handleInstitutionChange({ target: { value: values?.id || 0 } } as any);
								}}
								options={institutions}
								value={institutionId}
							/>
						</Grid>
					)}

					<TextField
						label={'curso'}
						onChange={(event: ChangeEvent<HTMLInputElement>) => {
							setCourseId(parseInt(event.target.value));
						}}
						select
						value={courseId}
					>
						<MenuItem value={0}> Selecciona un curso </MenuItem>

						{courses.map((course: ICourse) => (
							<MenuItem key={course.id} value={course.id}>
								{' '}
								{course.name}{' '}
							</MenuItem>
						))}
					</TextField>

					<FormControl fullWidth style={{ marginTop: 16 }}>
						<FormLabel> Año </FormLabel>

						<MuiPickersUtilsProvider
							locale={'es'}
							utils={MomentUtils}
						>
							<DatePicker
								InputProps={{
									endAdornment: <CalendarIcon />,
								}}
								autoOk
								format={'YYYY'}
								value={date}
								// NOTE:
								// ./src/modules/Private/Courses/Course.tsx[22:8]
								inputVariant={'outlined'}
								onChange={(date: any) => {
									setDate(date);
								}}
								views={['year']}
							/>
						</MuiPickersUtilsProvider>
					</FormControl>
				</Grid>
			}
			fullScreen={isMobile}
			handleOpen={handleOpen}
			maxWidth={'sm'}
			open={open}
			title={
				type == 'advances'
					? 'Bitácora de avance'
					: 'Reporte de calificaciones'
			}
		/>
	);
}
